import { lazy } from 'react';

export const PasswordResetLazy = lazy(() => import('./PasswordReset'));
